import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from 'src/app/dashboard/dashboard.component';
import { LoginComponent } from 'src/app/login/login.component';
import { HomeComponent } from 'src/app/pages/home/home.component';
import { PageNotFoundComponent } from 'src/app/pages/page-not-found/page-not-found.component';
import { OpenapiRenderComponent } from 'src/app/openapi-render/openapi-render.component';
import { HowToUseApisComponent } from 'src/app/pages/how-to-use-apis/how-to-use-apis.component';
import { ApiTutorialRendererComponent } from 'src/app/pages/api-tutorial/api-tutorial.component';



// /dash/... routes
// these are all displayed in dashboard router-outlet
export const dashRoutes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'how-to-use-apis', component: HowToUseApisComponent },
  { path: 'api-tutorial/:page', component: ApiTutorialRendererComponent },
  { path: 'oapi-render/:name', component: OpenapiRenderComponent },
];

export const loginRoutes: Routes = [
  { path: 'login', component: LoginComponent },
];

export const notFoundRoute: Routes = [
  { path: '404', component: PageNotFoundComponent },
  { path: '**', redirectTo: '/404' }, // This route must always be the last route in the 'notFoundRoute' array. Only enter new routes above this one
];

export const routes: Routes = [
  // home
  { path: '', redirectTo: '/dash/home', pathMatch: 'full' },
  // dashboard, all other editors/pages are displayed through dashboard router-outlet
  { path: 'dash', component: DashboardComponent, children: dashRoutes },
  ...loginRoutes,
  ...notFoundRoute
]


@NgModule({
  imports: [
    RouterModule.forRoot([]),
  ],
  exports: [
    RouterModule,
  ]
})
export class AppRoutingModule { }
